<template>
<div class="admin-page-content">
    <div class="container-fluid xyz">
            <div v-if="!isCancelConfirmed" class="error-detail-main forms-container">
                <div class="page-header-top-container">
                </div>
                  <div class="row">
                    <div class="col-md-6 form-group" id="customerForm">
                      <div class="forms-container">
                        <div class="row">
                          <div class="col-md-12 page-header-bottom-container">
                            <h3>Personal Information</h3>
                          </div>
                          <div class="col-md-12 forms-block mt-2">
                              <div class="form-label" for="customerName">Customer Name : {{ customerName }}</div>
                          </div>
                          <!--FirstName-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="email">First Name</label>
                              <div class="requiredstar">*</div>
                              <input v-model="custFirstName" type="text" class="form-control" id="custFirstName" placeholder="First Name" autocomplete="off" readonly>
                              <font class="text-danger">{{custFirstNameError}}</font>
                          </div>
                          <!--LastName-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="custLastName">Last Name</label>
                              <div class="requiredstar">*</div>
                              <input v-model="custLastName" type="text" class="form-control" id="custLastName" placeholder="Last Name" autocomplete="off" readonly>
                              <font class="text-danger">{{custLastNameError}}</font>
                          </div>
                          <!--CustomerID-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="custcustomerId">Customer</label>
                              <input v-model="custcustomerId" type="text" class="form-control" id="custcustomerId" placeholder="Customer Id" :disabled="true">
                              <!-- <div class="requiredstar">*</div>
                              <font class="text-danger">{{custLastNameError}}</font> -->
                          </div>
                          <!--Order number-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="custorderId">Order Number</label>
                              <input v-model="custorderId" type="text" class="form-control" id="custorderId" placeholder="Order Number" :disabled="true">
                              <!-- <div class="requiredstar">*</div>
                              <font class="text-danger">{{custLastNameError}}</font> -->
                          </div>
                          <!--Order Amout-->
                          <div class="col-md-12 form-group form-bottom-set">
                              <label class="form-label" for="custorderAmtDisplay">Order Amount</label>
                              <sup style="color: #c3202b; font-size:12px;">1</sup>
                              <input v-model="custorderAmtDisplay" type="text" class="form-control" id="custorderAmtDisplay" placeholder="Order Amount" :disabled="true" style="margin-bottom:5px;">
                              <font class="text-order-amount"><sup style="color: #c3202b; font-size: 12px;">1</sup>TAX AMOUNTS MAY BE ESTIMATED OR MAY NOT BE INCLUDED. CUSTOMER SHALL PAY ALL TAXES ACTUALLY INCURRED AT THE TIME OF SALE.</font>
                              <!-- <div class="requiredstar">*</div>
                              <font class="text-danger">{{custLastNameError}}</font> -->
                          </div>
                          <!--Address1-->
                          <div class="col-md-12 form-group form-bottom-set">
                              <label class="form-label" for="customerName">Billing address on file for the credit card:</label>
                              <div class="requiredstar">*</div>
                              <input v-model="address1" type="text" class="form-control" id="address" placeholder="Example: 1234 Main Street" autocomplete="off" maxlength="30" readonly>
                              <font class="text-danger">{{address1Error}}</font>
                          </div>
                          <!--Address2-->
                          <div class="col-md-12 form-group form-bottom-set">
                              <label class="form-label" for="customerName">Address-2 :</label>
                              <input v-model="address2" type="text" class="form-control" id="address" placeholder="Example: Suite 201" autocomplete="off" readonly>
                              <!--div class="requiredstar">*</div>
                              <font class="text-danger">{{address2Error}}</font-->
                          </div>
                          <!--City-->
                          <div class="col-md-3 form-group form-bottom-set">
                              <label class="form-label" for="city">City</label>
                              <div class="requiredstar">*</div>
                              <input v-model="city" type="text" class="form-control" id="city" placeholder="City" autocomplete="off" readonly>
                              <font class="text-danger">{{cityError}}</font>
                          </div>
                          <!--State-->
                          <div class="col-md-4 form-group form-bottom-set">
                              <label class="form-label" for="city">State</label>
                              <div class="requiredstar">*</div>
                              <v-select v-model="state"
                                        @change="changedValue"
                                        @input="changedValueLocation()"
                                        name="locationId"
                                        id="locationId"
                                        label="Name"
                                        :filterable="false"
                                        :options="stateArr"
                                        :searchable="true"
                                        placeholder="Select State"
                                        @search="onSearchState"  readonly>
                                  <template slot="no-options">
                                      Search State...
                                  </template>
                                  <template slot="option" slot-scope="option">
                                      <div class="d-center">
                                          {{ option.Name }}
                                      </div>
                                  </template>
                                  <template slot="selected-option" slot-scope="option">
                                      <div class="selected d-center">
                                          {{ option.Name }}
                                      </div>
                                  </template>
                              </v-select>
                              <font class="text-danger">{{statusError}}</font>
                          </div>
                          <!--Zip-->
                          <div class="col-md-3 form-group form-bottom-set">
                              <label class="form-label" for="zip">Zip</label>
                              <div class="requiredstar">*</div>
                              <input v-model="zip" type="text" class="form-control" id="zip" placeholder="Mention zip" minlength="5" readonly>
                              <font class="text-danger">{{zipError}}</font>
                          </div>
                          <!--Country-->
                          <div class="col-md-2 form-group form-bottom-set">
                              <label class="form-label" for="city">Country</label>
                              <input type="text" class="form-control" id="country" value="US" disabled>
                              <!-- <div class="form-label" for="city">US</div> -->
                          </div>
                          <!--Main Phone-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="mainPhone">Main Phone</label>
                              <div class="requiredstar">*</div>
                              <input v-model="custmainPhone" class="form-control" id="mainPhone" placeholder="Main Phone" readonly>
                              <font class="text-danger">{{custmainPhoneError}}</font>
                          </div>
                          <!--Other Phone-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="custOtherPhone">Other Phone</label>
                              <input v-model="custOtherPhone" type="text" class="form-control" id="custOtherPhone" placeholder="Other Phone" readonly>
                              <!--div class="requiredstar">*</div>
                              <font class="text-danger">{{custOtherPhoneError}}</font-->
                          </div>
                          <!--Email-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="email">Email</label>
                              <div class="requiredstar">*</div>
                              <input v-model="custEmail" type="text" class="form-control" id="email" placeholder="example123@example.com" readonly>
                              <font class="text-danger">{{custEmailError}}</font>
                          </div>
                          <!--Email-2-->
                          <div class="col-md-6 form-group form-bottom-set">
                              <label class="form-label" for="email">Email 2</label>
                              <input v-model="custEmail2" type="text" class="form-control" id="email2" placeholder="example123@example.com" readonly>
                              <font class="text-danger">{{custEmail2Error}}</font>
                          </div>
                          <!--Email-3-->
                          <div class="col-md-12 form-group form-bottom-set">
                              <label class="form-label" for="email">Email 3</label>
                              <input v-model="custEmail3" type="text" class="form-control" id="email3" placeholder="example123@example.com" readonly>
                              <font class="text-danger">{{custEmail3Error}}</font>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-group" id="customerForm">
                        <div class="forms-container" style="height: 100%;">
                        <div class="row">
                          <div class="col-md-12 page-header-bottom-container">
                            <h3>Card Details</h3>
                          </div>
                          <div class="col-md-12 form-group mt-2 form-bottom-set">
                              <div style="line-height: 2;">
                              I, <input  v-model="fullName" type="text" class="col-11 form-control d-inline-block" id="custFirstName" placeholder="Full Name as it appears on the Credit Card" maxlength="30" readonly/> authorize Velocity Vehicle Group (and their affiliates) to charge my credit card.
                              </div>
                              <font class="text-danger">{{ acknowladgementError }}</font>
                          </div>
                          <div class="col-md-12 form-group form-bottom-set">
                            <label class="form-label" for="email">Card Number</label>
                            <div class="requiredstar">*</div>
                            <div class="input-group mb-0">
                              <div class="input-group-prepend">
                                  <span class="input-group-text">
                                      <img :src="cardBrandDisp" alt="card">
                                  </span>
                              </div>
                              <input ref="cardNumInput" v-model="cardNumber" class="form-control"
                                placeholder="#### #### #### ####" v-cardformat:formatCardNumber readonly>
                            </div>
                            <font class="text-danger">{{cardNumberError}}</font>
                          </div>
                          <!--Expiry Month-->
                          <div class="col-md-4 form-group form-bottom-set">
                              <label class="form-label" for="email">Expiry Month</label>
                              <div class="requiredstar">*</div>
                              <input class="form-control" type="text" v-model="expMonth" placeholder="MM" readonly/>
                              <font class="text-danger">{{expMonthError}}</font>
                          </div>

                          <!--Expiry Year-->
                          <div class="col-md-4 form-group form-bottom-set">
                              <label class="form-label" for="email">Expiry Year</label>
                              <div class="requiredstar">*</div>
                              <input class="form-control" type="text" v-model="expYear" placeholder="YYYY" readonly/>
                              <font class="text-danger">{{expYearError}}</font>
                          </div>
                          <!--CVV-->
                          <div class="col-md-4 form-group form-bottom-set">
                              <label class="form-label" id="cvvId" data-toggle="tooltip">CVV</label>
                              <div class="requiredstar" >*</div>
                              <i class="fa fa-question-circle"></i>
                              <b-tooltip target="cvvId" title="3 digits code on back side of the card" placement="top"></b-tooltip>
                              <input v-model="cvv" class="form-control" required="" type="text" v-cardformat:formatCardCVC readonly>
                              <font class="text-danger">{{cvvError}}</font>
                          </div>
                          <!--Keep Card on File-->
                          <div v-if="showCheckBox" class="col-md-12 form-check form-group form-bottom-set" style="padding-left: 3rem;">
                            <label class="checkbox-bootstrap checkbox-lg form-label d-block">
                                <input v-model="keepCardOnFile" type="checkbox" readonly>
                                <span class="checkbox-placeholder"></span>
                                Keep Card on File
                            </label>
                          </div>
                          <font v-if="showCheckBox" class="text-danger" style="padding-left: 1rem;">{{keepCardText}}</font>
                          <!--Notes-->
                          <div class="col-md-12 form-group form-bottom-set">
                              <div class="form-label" for="customerName" style="padding: 3px 1px 7px;">Notes</div>
                              <textarea v-model="note" type="text" class="form-control" id="note" readonly></textarea>
                          </div>
                          <!--Declaration-->
                          <div class="col-md-12 form-group form-bottom-set">
                            <div style="padding:1rem 1rem 1rem 2.9rem; background: #DBEFFC 0% 0% no-repeat padding-box;opacity: 1;border-radius:3px">
                            <label class="checkbox-bootstrap checkbox-lg">
                                <input v-model="isAcceptDeclaration" type="checkbox">
                                <span class="checkbox-placeholder" style="background-color: white;"></span>
                                {{ DeclarationText }} <a href="https://www.velocityvehiclegroup.com/privacy" target="_blank"><u>VVG Group Terms and Condition & its Privacy Policy</u></a>
                            </label>
                            </div>
                          </div>

                          <div class="col-md-12 form-group form-bottom-set">
                              <label class="form-label" for="customerName">Signature of Cardholder</label>
                              <div class="requiredstar">*</div>
                              <input v-model="customerSignedName" type="text" class="form-control" ref="signature" placeholder="Please Enter Cardholder Full Name" :disabled="!disableSignature">
                              <font class="text-danger">{{customerSignedNameError}}</font>
                          </div>
                          <div class="col-md-12 form-group form-bottom-set">
                              <label class="form-label" for="customerName">By typing your name above, you are signing this form electronically. You agree that your electronic signature is the legal equivalent of your manual signature on this form</label>
                          </div>
                          <template v-if="showSignDate">

                            <div class="col-md-12 form-group form-bottom-set">
                                <label class="form-label" for="customerName">Signature Date</label>
                                <input :disabled="true" :value="formSignatureStatusDate" type="text" class="form-control" id="email3" placeholder="Please Enter Cardholder Full Name">
                            </div>
                          </template>

                          <div v-if="showCheckBox" class="col-md-12 form-check form-group form-bottom-set" style="padding-left: 3rem;padding-top: 1rem;padding-bottom: 1rem;">
                              <label class="checkbox-bootstrap checkbox-lg">
                                  <input v-model="isAddPassword" type="checkbox">
                                  <span class="checkbox-placeholder"></span>
                                  Add Password
                              </label>
                              <input v-show="isAddPassword" placeholder="Password" v-model="password" class="col-7" :type="isPassword">
                              <button v-show="isAddPassword" v-on:click.prevent="showPassword(isShowPassword)">
                                  <i v-show="!isShowPassword" class="fa fa-eye-slash" aria-hidden="true" style="padding: 6px;"></i>
                                  <i v-show="isShowPassword" class="fa fa-eye" aria-hidden="true" style="padding: 6px;"></i>
                              </button>
                              <font class="text-danger">{{setPasswordError}}</font>
                          </div>
                        </div>
                        </div>



                    </div>
                  </div>
                    <!-- <div class="center">
                      <a href="https://www.velocityvehiclegroup.com/privacy" target="_blank">VVG Privacy Policy</a>
                    </div> -->
                    <div class="help is-danger">{{error_msg_login}}</div>
                  <!--Buttons-->
                  
                  <div class="text-right mt-4">
                        <!-- <input id="printBtn" type="button" value="Print" class="btn btn-primary " v-on:click.prevent="printDetails()"> -->
                  </div>
            </div>
            <div v-if="isCancelConfirmed" class="error-detail-main forms-container">
                <div class="page-header-top-container">
                </div>
                  <div class="row">
                    <div class="col-md-12 form-group" id="customerForm2">
                        <div class="row">
                          <div class="col-md-12 page-header-bottom-container">
                            <h3 class="text-center">You have cancelled the submission, please close this window.</h3>
                          </div>
                        </div>
                    </div>
                  </div>
            </div>
    </div>

    <!-- Password Modal -->
    <div class="modal fade" id="passwordModal" tabindex="-1" role="dialog" aria-labelledby="passwordModalLabel" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
                <h5 class="modal-title" id="passwordModalLabel">Enter Password</h5>
                <input type="password" v-model="password" ref="passwordField" class="form-control"  placeholder="Enter Password"  @keydown="handleKeyDown">
                <div class="mt-10">
                  <button type="button"  class="btn btn-primary pull-right ml-10" @click="submitForm">Submit</button>
                  <button type="button" class="btn btn-secondary pull-right ml-10" data-dismiss="modal">Close</button>
                </div>
          </div>
        </div>
      </div>
    </div>


    <app-footer></app-footer>
</div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script src="../dist/vue-credit-card-validation.js"></script>

<script>
var self;
import Vue from 'vue';
import Footer from '@/components/partials/Footer';
import EventBus from '.././event-bus';
import {
    commonMixins
} from '../../mixins/commonMixins';
import NoAccessPermission from '@/components/AccessDenied/NoAccessPermission';
import {
    HTTP
} from '../../http-common';
import vSelect from 'vue-select';

import VueCardFormat from 'vue-credit-card-validation';

Vue.use(VueCardFormat);

import moment from 'moment'

import Multiselect from 'vue-multiselect';



export default {
    name: 'CustomerCardDetailInternal',
    components: {
        'app-footer': Footer,
        "no-permission": NoAccessPermission,
        'v-select': vSelect,
        Multiselect,
    },
    mixins: [commonMixins],
    data() {
        return {
          showCheckBox: true,
          index:0,
            expYearList: [{"year" : 2000},{"year" : 2001},{"year" : 2003}],
            expMonthList: [{"month" : '01'},{"month" : '02'},{"month" : '03'},{"month" : '04'},{"month" : '05'},{"month" : '06'},
            {"month" : '07'},{"month" : '08'},{"month" : '09'},{"month" : '10'},{"month" : '11'},{"month" : '12'}],

            isPassword: "password",
            isShowPassword: false,
            showSignDate: false,

            $cardFormat: Vue.prototype.$cardFormat,

            cardBrand: '/static/images/credit-card.png',
            cardBrandDisp: '/static/images/credit-card.png',
            cardErrors: {},
            isSave: false,
            disableSignature: false,

            customerSignedName: "",
            customerSignedNameError: "",
            setPasswordError: "",

            ccAuthFormId: "",
            acknowladgementError: "",

            // isVise: false,
            // isMaster: false,
            // isAmerican: false,
            // isDiscover: false,
            customerName: "",
            password: "",
            fullName: "",
            isAddPassword: false,
            isAcceptDeclaration: true,
            // FORM
            custFirstName: "",
            custFirstNameError: "",
            custLastName: "",
            custLastNameError: "",

            address1: "",
            address1Error: "",
            address2: "",
            address2Error: "",
            city: "",
            cityError: "",
            state: "",
            stateArr: [],
            stateError: "",
            zip: "",
            zipError: "",
            country: "",

            custmainPhone: "",
            custmainPhoneError: "",
            custOtherPhone: "",
            custOtherPhoneError: "",

            custEmail: "",
            custEmailError: "",
            custEmail2: "",
            custEmail2Error: "",
            custEmail3: "",
            custEmail3Error: "",

            cardUsername: "",
            cardUsernameError: "",
            cardNumber: "",
            cardNumberError: "",

            expMonth: "",
            expMonthError: "",
            expYear: "",
            expYearError: "",
            cvv: "",
            cvvError: "",
            status: "",
            statusError: "",
            keepCardOnFile: false,
            note: "",
            formSignatureStatusDate: "",

            // HIDE
            custBranchId: "",
            custcustomerId: "",
            custorderAmt: "",
            custorderAmtTax: "",
            custorderAmtDisplay: "",
            BillCusId: "",
            AccountType: "",
            OrderAmtEstimateFlag: "",
            InvoiceSlsId: "",
            custorderId: "",

            disableButtons: false,
            disableorderIdBtn: false,
            error_msg_login: "",
            keepCardText: "",

            isDisable: false,
            CCAuthFormDeclarationId: 0,
            DeclarationText: '',
            isAcceptDeclarationError: '',
            cardType: '',
            isCancelConfirmed: false,
            isInternal: false,
            userId: 0,
            password: ''
        }
    },
    beforeMount: function () {
        self = this;
    },
    mounted: function () {
        $('#passwordModal').modal('show'); // Show the modal

        // var passChange = localStorage.getItem('showCustomerForm');
        // if (passChange != null && passChange !== "" && passChange !== "0") {
        //     $('#customerForm').show();
        //     self.ccauthFormId = localStorage.getItem('ccauthFormId');
        //     self.isInternal = localStorage.getItem('isInternal');
        //     self.userId = localStorage.getItem('user_id');
        //     self.getCCAuthFormData();
        // } else {
        //     // $('#customerForm').hide();
        //     // $('#customerForm').show();
        // }
        self.getStatesData();
        self.setExpYearList();
    },
    watch: {
      isVise : function(isVise) {
        if(isVise) {
          self.isMaster = false;
          self.isAmerican = false;
          self.isDiscover = false;
        }
      },
      isMaster : function(isMaster) {
        if(isMaster) {
          self.isVise = false;
          self.isAmerican = false;
          self.isDiscover = false;
        }
      },
      isAmerican : function(isAmerican) {
        if(isAmerican) {
          self.isVise = false;
          self.isMaster = false;
          self.isDiscover = false;
        }
      },
      isDiscover : function(isDiscover) {
        if(isDiscover) {
          self.isVise = false;
          self.isMaster = false;
          self.isAmerican = false;
        }
      },
      keepCardOnFile : function(keepCardOnFile) {
        if(keepCardOnFile) {
          if(self.AccountType == 'ACCT') {
            self.keepCardText = "IF YOU CHECK KEEP THIS ON FILE, IT MAY BE USED AT ALL VVG LOCATIONS";
          } else if (self.AccountType == 'CASH') {
            self.keepCardText = "You will be notified by our Accounting team for a new unique customer#";
          }

        } else {
          self.keepCardText = "";
        }
      },
      customerSignedName: function(customerSignedName) {
        if(!self.customerSignedName || self.customerSignedName === null || self.customerSignedName === "" || self.customerSignedName.length == 0) {
          self.isSave = false;
          self.showSignDate = false;
        } else {
          if(self.isAcceptDeclaration) {
            self.isSave = true;
            self.showSignDate = true;
          } else {
            self.isSave = false;
            self.showSignDate = false;
          }
          // self.isSave = true;

        }
      },
      isAcceptDeclaration: function(isAcceptDeclaration) {
        if(isAcceptDeclaration) {
          // self.isSave = true;
          self.disableSignature = true;
          this.$nextTick(() => this.$refs.signature.focus());
        } else {
          self.isSave = false;
          self.disableSignature = false;
        }
      },
      custmainPhone: function(custmainPhone) {
        self.custmainPhone = self.phoneValidate(custmainPhone);
      },
      custOtherPhone: function(custOtherPhone) {
        self.custOtherPhone = self.phoneValidate(self.custOtherPhone);
      },
      cardBrand: function(cardBrand) {
        // if(self.index == 0){
        if(self.cardNumber.length <= 2){
          console.log(self.cardNumber.length);
          if(cardBrand != "") {
            var icon  = self.getBrandClass(cardBrand);
            if(icon != "") {
                self.cardBrandDisp = self.getBrandClass(cardBrand);
            }
         }
       }
       console.log(self.cardBrandDisp);
       self.index++;
      },
      custEmail: function(custEmail) {
        if(custEmail === null || custEmail === "") {
          self.custEmailError = '';
        } else {
          if (!self.validEmail(custEmail)) {
            self.custEmailError = 'Please Enter Valid Email';
          } else {
            self.custEmailError = '';
          }
        }
      },
      custEmail2: function(custEmail2) {
        if(custEmail2 === null || custEmail2 === "") {
          self.custEmail2Error = '';
        } else {
          if (!self.validEmail(custEmail2)) {
            self.custEmail2Error = 'Please Enter Valid Email';
          } else {
            self.custEmail2Error = '';
          }
        }
      },
      custEmail3: function(custEmail3) {
        if(custEmail3 === null || custEmail3 === "") {
          self.custEmail3Error = '';
        } else {
          if (!self.validEmail(custEmail3)) {
            self.custEmail3Error = 'Please Enter Valid Email';
          } else {
            self.custEmail3Error = '';
          }
        }
      },
      custFirstName: function(custFirstName) {
        self.custFirstName = self.removesymbol(self.custFirstName);
        if(self.custFirstName.length > 0) {
          self.custFirstNameError = "";
        }
      },
      custLastName: function(custLastName) {
        self.custLastName = self.removesymbol(self.custLastName);
        if(self.custLastName.length > 0) {
          self.custLastNameError = "";
        }
      },
      fullName: function(fullName) {
        if(self.fullName.length > 0) {
          self.acknowladgementError = "";
        }
      },
      address1: function(address1) {
        self.address1 = self.removesymbol(self.address1);
        if(self.address1.length > 0) {
          self.address1Error = "";
        }
      },
      address2: function(address1) {
        self.address2 = self.removesymbol(self.address2);
      },
      city: function(city) {
        self.city = self.removesymbol(self.city);
        if(self.city.length > 0) {
          self.cityError = "";
        }
      },
      zip: function(zip) {
        if(self.zip.length > 0) {
          if(!self.zipCodeValidate(self.zip)) {
              self.zipError = "The Zip code is required.";
          } else {
              self.zipError = "";
          }
        }
      },



    },
    methods: {
      handleKeyDown(event) {
            if (event.key === 'Enter') {
              event.preventDefault();
              self.submitForm();
            }
        },
        submitForm(){
          // self.password = prompt("Enter Password", "password")
          var passChange = localStorage.getItem('showCustomerForm');
          if(self.password == '') {
            alert('Please enter password!');
          }else if (passChange != null && passChange !== "" && passChange !== "0" && self.password !== null) {
              $('#passwordModal').modal('hide'); // Hide the modal

              $('#customerForm').show();
              self.ccauthFormId = localStorage.getItem('ccauthFormId');
              self.isInternal = localStorage.getItem('isInternal');
              self.userId = localStorage.getItem('user_id');
              self.getCCAuthFormData();
          } else {
            
              // $('#customerForm').hide();
              // $('#customerForm').show();
          }
        },
        setExpYearList: function() {
          self.expYearList = [];
          for (let index = 0; index < 10; index++) {
            var d = new Date();
            var year = d.getFullYear();
            var c = new Date(year + index, d.getMonth(), d.getDate());
            const tag = {
              year: c.getFullYear(),
            }
            self.expYearList.push(tag)
          }
          // expYearList
        },
        addYear (newTag) {
          if(newTag.length < 4) {

            self.expYearError = "Please enter valid year";

          } else {

            var d = new Date();
            var year = d.getFullYear();

            if(year > newTag) {
              self.expYearError = "Invalid expiry year";
            } else {
              self.expYearError = "";
              const tag = {
                year: newTag,
              }
              this.expYearList.push(tag)
              this.expYear = tag;
              this.expYearList.sort(function(a, b){return a.year - b.year});
            }

          }

        },
        setMoment: function() {
            return moment(String(new Date())).format('MM/DD/YYYY').toLocaleString('en-US', { timeZone: 'America/New_York' });
        },
        showPassword: function(showPass) {
          if(showPass) {
            self.isPassword = "password";
            self.isShowPassword = false;
          } else {
            self.isPassword = "text";
            self.isShowPassword = true;
          }
        },
        getBrandClass: function (brand) {
          // if(self.cardNumber.length <= 2){
            let icon = '';
            brand = brand || 'unknown';
            let cardBrandToClass = {
              'visa': '/static/images/visa.png',
              'mastercard': '/static/images/mastercard.png',
              'amex': '/static/images/amex.png',
              'discover': '/static/images/discover.png',
              'dinersclub': '/static/images/diners-club.png',
              'jcb': '/static/images/jcb.png',
              'unionpay': '/static/images/unionpay.png',
              'unknown': '/static/images/credit-card.png',
            };

            if (cardBrandToClass[brand]) {
              icon = cardBrandToClass[brand];
            };

            let cardTypeSet = {
              'visa': 'Visa',
              'mastercard': 'Master',
              'amex': 'Amex',
              'discover': 'Discover',
              'dinersclub': 'Dinersclub',
              'jcb': 'JCB',
              'unionpay': 'Unionpay',
              'unknown': 'Unknown',
            };

            if (cardTypeSet[brand]) {
              self.cardType = cardTypeSet[brand];
            };
          return icon;
          // }
        },
        onSearchState(search, loading) {
            if (search.length > 1) {
                if (typeof (loading) != "undefined") {loading(true);}
                this.getStatesData(loading, search);
            }
        },
        getStatesData: function (loading, search) {

          var fields = {
            search: search,
          };

          HTTP.post("get/states", fields)
              .then(function (response) {
                console.log(response);
                // self.stateArr = response.data.content;
                self.stateArr = [];
                $.each(response.data.content, function (i) {
                    /*if (i == 0) {
                      self.siteid = response.data.content[i];
                      }*/
                    self.stateArr.push(response.data.content[i]);
                });
                if (typeof (loading) != "undefined") {
                    loading(false);
                }
              })
              .catch(function (error) {
                  console.log(error);
                  self.hideLoader();
                  self.error_msg_login = "";
                  if (error.response.status == 0) {
                      self.error_msg_login = "Remote server can not be reachable";
                  } else {
                      if (error.response.data.message) {
                          self.error_msg_login = error.response.data.message;
                      }
                  }
              })
        },
        getCCAuthFormData: function () {
            var error = false;

            if (!self.ccauthFormId || self.ccauthFormId == null || self.ccauthFormId == "") {
                self.error_msg_login = "The CCAUTHFORMID is required.";
                error = true;
            }
            if (!error) {
                self.showLoader();
                var fields = {
                    ccAuthFormId: self.ccauthFormId,
                    userId: self.userId,
                    userPassword: self.password
                };

                const formatter = new Intl.NumberFormat('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                                minimumFractionDigits: 2
                                              });

                HTTP.post("get/ccauthformdata/internal", fields)
                    .then(function (data) {
                        self.hideLoader();
                        if (data.status == 200) {
                          self.custEmail = data.data.content.Email;
                          self.custBranchId = data.data.content.BranchId;
                          self.custcustomerId = data.data.content.CustomerId;
                          self.customerName = data.data.content.CustomerName;
                          self.custFirstName = data.data.content.FirstName;
                          self.custLastName = data.data.content.LastName;
                          self.fullName = data.data.content.BillName;
                          self.address1 = data.data.content.BillAddress1;
                          self.address2 = data.data.content.BillAddress2;
                          self.city = data.data.content.BillCity;
                          self.state = data.data.content.BillStateCode;
                          self.zip = data.data.content.BillZipCode;
                          self.country = data.data.content.BillCountryCode;
                          self.custEmail2 = data.data.content.Email2;
                          self.custEmail3 =  data.data.content.Email3;
                          self.custOtherPhone =  data.data.content.OtherPhone;
                          self.note =  data.data.content.Notes;
                          self.customerSignedName =  data.data.content.CustomerSignedName;
                          self.custorderAmtDisplay = formatter.format(data.data.content.OrderAmt);
                          self.custorderAmtTax = formatter.format(data.data.content.OrderAmtTax);
                          self.BillCusId = data.data.content.BillCusId;
                          self.AccountType = data.data.content.AccountType;
                          self.OrderAmtEstimateFlag = data.data.content.OrderAmtEstimateFlag;
                          self.InvoiceSlsId = data.data.content.InvoiceSlsId;
                          self.custorderId = data.data.content.OrderId;
                          self.CCAuthFormDeclarationId = data.data.content.CCAuthFormDeclarationId;
                          self.DeclarationText = data.data.content.DeclarationText;
                          self.custmainPhone = self.phoneValidate(data.data.content.MainPhone);
                          self.cardNumber = data.data.content.AccountNumber;
                          self.cvv = data.data.content.CardVerificationNumber;
                          self.CardChargingPassword = data.data.content.CardChargingPassword;
                          self.expYear = data.data.content.CardExpYear;
                          self.expMonth = data.data.content.CardExpMonth;
                          self.formSignatureStatusDate = data.data.content.FormSignatureStatusDate;
                          self.keepCardOnFile = data.data.content.KeepCardOnFileFlag == 1 ? true : false;
                          if(self.custcustomerId){
                            var custStart = self.custcustomerId.substring(0, 4);
                            if(custStart === 'cash' || custStart === 'CASH'){
                              self.showCheckBox = false;
                            }
                          }
                        } else {
                            self.error_msg_login = data.data.message;
                        }
                    })
                    .catch(function (error) {
                        console.log(error.response);
                        if(error.response.data.code == 401) {
                          alert("You do not have access to this page, please contact IT");
                        }else if(error.response.data.code == 400 && error.response.data.message){
                          alert(error.response.data.message);
                        }
                        self.error_msg_login = "";
                        // self.changePasswordBtn = "Submit";
                        // self.disableButtons = false;
                        self.hideLoader();
                        /*$('#loginbtn').text("Login");
                        $("#loginbtn").attr("disabled", false);*/
                        if (error.response.status == 0) {
                            self.error_msg_login = "Remote server can not be reachable";
                        } else {
                            if (error.response.data.message) {
                                self.error_msg_login = error.response.data.message;
                            }
                        }
                    })
            }

        },
        cancelOrderDetailForm: function () {
            /* if (window.confirm('Are you sure you want to Cancel?')) {
              self.isCancelConfirmed = true;
            }  */
            self.$swal({
            title: '',
            text: 'Are you sure you want to Cancel?',
            type: 'info',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showCancelButton: true,
            /* showCloseButton: true, */
            showLoaderOnConfirm: true
            }).then((result) => {
              if (result.value) {
                self.isCancelConfirmed = true;
              } else {
                self.isCancelConfirmed = false;
              }           
            });
        },
        saveCustomerDetail: function () {
            var error = false;
            self.error_msg_login = "";
            self.custFirstNameError = "";
            self.acknowladgementError = "";
            self.custLastNameError = "";
            self.address1Error = "";
            self.cityError = "";
            self.custEmailError = "";
            self.custEmail2Error = "";
            self.custEmail3Error = "";
            self.cardNumberError = "";
            self.cardUsernameError = "";
            self.zipError = "";
            self.custmainPhoneError = "";
            self.expMonthError = "";
            self.cvvError = "";
            self.stateError = "";
            self.customerSignedNameError = "";
            self.isAcceptDeclarationError = "";


            this.cardErrors = {};




            if (!self.isAcceptDeclaration) {
                self.isAcceptDeclarationError = "Please accept declaration.";
                error = true;
            }
            if (self.isAddPassword) {
              if (!self.password || self.password == null || self.password == "") {
                  self.setPasswordError = "Please set Password.";
                  error = true;
              }
            }

            if (!self.fullName || self.fullName == null || self.fullName == "") {
                self.acknowladgementError = "Please enter full name.";
                error = true;
            } else if(self.fullName.length > 30) {
                self.acknowladgementError = "Name on Card should not be greater than 30 chars. Please use First Name and Last Name, or Company Name, but NOT both even if both name printed on card.";
                error = true;
            }
            if (!self.custFirstName || self.custFirstName == null || self.custFirstName == "") {
                self.custFirstNameError = "The FirstName is required.";
                error = true;
            }
            if (!self.custLastName || self.custLastName == null || self.custLastName == "") {
                self.custLastNameError = "The LastName is required.";
                error = true;
            }
            if (!self.address1 || self.address1 == null || self.address1 == "") {
                self.address1Error = "Billing address on file for the credit card required.";
                error = true;
            }
            if (!self.city || self.city == null || self.city == "") {
                self.cityError = "The City is required.";
                error = true;
            }
            if (!self.state || self.state == null || self.state == "") {
                self.statusError = "The State is required.";
                error = true;
            }
            if (self.zip.length <= 5) {
                if(!self.zipCodeValidate(self.zip)) {
                  self.zipError = "The Zip code is required.";
                  error = true;
                }

            }
            if (!self.custmainPhone || self.custmainPhone == null || self.custmainPhone == "") {
                self.custmainPhoneError = "The Main Phone Number is required.";
                error = true;
            }
            if (!self.custEmail || self.custEmail == null || self.custEmail == "") {
                self.custEmailError = "The Email is required.";
                error = true;
            } else if (!self.validEmail(self.custEmail)) {
              self.custEmailError = 'Please Enter Valid Email';
              error = true;
            }

            if(self.custEmail2 === null || self.custEmail2 === "") {

            } else {
              if (!self.validEmail(self.custEmail2)) {
                self.custEmail2Error = 'Please Enter Valid Email';
                error = true;
              }
            }

            if(self.custEmail3 === null || self.custEmail3 === "") {

            } else {
              if (!self.validEmail(self.custEmail3)) {
                self.custEmail3Error = 'Please Enter Valid Email';
                error = true;
              }
            }



            if (!self.cardNumber || self.cardNumber == null || self.cardNumber == "") {
                self.cardNumberError = "The Card number is required.";
                error = true;
            } else if(!this.$cardFormat.validateCardNumber(this.cardNumber)){
                self.cardNumberError = "Invalid Credit Card Number.";
                error = true;
            }

            var d = new Date();
            var currentMonth = d.getMonth() + 1;
            var currentYear = d.getFullYear();
            if (!self.expMonth || self.expMonth == null || self.expMonth == "") {
                self.expMonthError = "The Card Expiration Month is required.";
                error = true;
            } else {

              if(self.expYear.year === currentYear && self.expMonth.month >= currentMonth) {
                this.expMonthError = "";
              } else if(self.expYear.year > currentYear) {
                this.expMonthError = "";
              } else {
                this.expMonthError = "The Card is Expired.";
                error = true;
              }

            }


            if (!self.expYear || self.expYear == null || self.expYear == "") {
                self.expYearError = "The Card Expiration Year is required.";
                error = true;
            } else {
              if(self.expYear.year > currentYear || (self.expYear.year === currentYear && self.expMonth.month >= currentMonth)) {
                this.expYearError = "";
              } else {
                this.expYearError = "The Card is Expired.";
                error = true;

              }
            }

            if (!self.cvv || self.cvv == null || self.cvv == "") {
                self.cvvError = "The Card CVV is required.";
                error = true;
            } else if (!this.$cardFormat.validateCardCVC(this.cvv)) {
                this.cvvError = "Invalid CVC.";
                error = true;
            }

            if (!self.customerSignedName || self.customerSignedName == null || self.customerSignedName == "") {
                self.customerSignedNameError = "The Customer Signature is required.";
                error = true;
            }

            console.log(error);

            if (!error) {
               self.addCCAuthFormCardData();
            }
        },
        addCCAuthFormCardData: function () {
          self.showLoader();
          self.orderIdBtn = "Submitting...";
          var fields = {
            CCAuthFormId: self.ccauthFormId,
            BranchId: self.custBranchId,
            CustomerId: self.custcustomerId,
            BillCusId: self.BillCusId,
            AccountType: self.AccountType,
            OrderId: self.custorderId,
            OrderAmt: self.custorderAmt,
            OrderAmtTax: self.custorderAmtTax,
            OrderAmtEstimateFlag: self.OrderAmtEstimateFlag,
            InvoiceSlsId: self.InvoiceSlsId,
            FormStatus: "RCVD",
            Email: self.custEmail,
            MainPhone: self.custmainPhone,
            UserId: null,
            CustomerName: self.customerName,
            FirstName: self.custFirstName,
            LastName: self.custLastName,
            BillName: self.fullName,


            BillAddress1: self.address1,
            BillAddress2: self.address2,
            BillCity: self.city,
            BillStateCode: self.state.StateCode,
            BillZipCode: self.zip,
            BillCountryCode: 'US',
            Email_2: self.custEmail2,
            Email_3: self.custEmail3,
            OtherPhone: self.custOtherPhone,
            Notes: self.note,

            CardType: self.cardType,
            AccountNumber: self.cardNumber.replace(/\s/g,''),
            CardExpMonth: self.expMonth.month,
            CardExpYear: self.expYear.year,
            CardVerificationNumber: self.cvv,
            ChargingPassword: self.password,
            KeepCardOnFileFlag: self.keepCardOnFile,

            OneTimeChargeFlag: 0,
            OneTimeChargeAmt: 0,
            ActiveFlag: 0,
            CustomerSignedName: self.customerSignedName,
            CCAuthFormDeclarationId: self.CCAuthFormDeclarationId,
            // CustomerSignedIPAddress: "192.168.1.1",
          };

          HTTP.post("add/ccauthformcarddata", fields)
              .then(function (data) {
                console.log(data);
                  self.hideLoader();
                  self.disableorderIdBtn = true;
                  self.$swal('Success', 'Your Information is submitted successfully to Velocity Vehicle Group', 'success');
                  setTimeout(function () {
                    localStorage.clear();
                    var win = window.open("about:blank", "_self");
                    win.close();
                  }, 3000);
                  self.disableorderIdBtn = false;
                  self.state = "";

                  if (data.data.code == 200) {
                    // self.getOrderDetail();

                  }
              })
              .catch(function (error) {
                  console.log(error);
                  self.hideLoader();
                  $('#orderForm').hide();
                  self.error_msg_login = "";
                  self.orderIdBtn = "Submit";
                  self.disableorderIdBtn = false;
                  /*$('#loginbtn').text("Login");
                  $("#loginbtn").attr("disabled", false);*/
                  if (error.response.status == 0) {
                      self.error_msg_login = "Remote server can not be reachable";
                  } else {
                      if (error.response.data.message) {
                          self.error_msg_login = error.response.data.message;
                      }
                  }
              })

        },
        changedValue: function (value) {
            //console.log(value);
        },
        changedValueLocation: function () {
            self.statusError = "";
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        phoneValidate(phoneNumber) {
          var x = phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          var phone =  !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
          return self.removeNonNumber(phone);
        },
        removeNonNumber(string) {
          return string.replace(/[^0-9]/g, '');
        },
        removesymbol(string) {
          let symbol = ["%","&","*","#","@",",","."];
          for (let i = 0; i < symbol.length; i++) {
            string = string.replace(symbol[i], '');
          }
          return string;
        },
        zipCodeValidate(zipCode) {
          return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
        }

    }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  .requiredCls {
    max-width: 20.333333% !important;
  }
  .requiredstar{
    position: unset;
    display: inline-block;
  }
  .text-danger {
    font-size: 14px;
    line-height: 18px;
    display: block;
  }
  :root label.checkbox-bootstrap input[type=checkbox] + span.checkbox-placeholder{
    margin: 0 7px 0 -35px;
  }
  .page-header-top-container{
    float: none;
    width: auto;
  }
  @media (max-width: 767px) {
    .app-sidebar-right{
      padding-left:0!important;
    }
    .admin-page-content {
      padding: 0;
    }
  }
  .form-bottom-set {margin-bottom: 0.5rem;}
  .text-order-amount {
    font-size: 12px;
    line-height: 18px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Order/CustomerCardDetailInternal.vue